// ============================================================================
// URL de compra de Shopify.
// Reemplazá el valor de SHOPIFY_URL por la URL exacta de tu producto o
// checkout de Shopify (ej: "https://mitienda.myshopify.com/products/basta-de-sostenerlo-todo").
// TODOS los botones de compra de la página usan esta única constante.
// ============================================================================
export const SHOPIFY_URL =
  'https://vskr1a-08.myshopify.com/cart/add?id=59627726569758&quantity=1'

// Loox: reseñas públicas del ebook. El Public Store ID permite usar la
// Storefront API sin exponer claves privadas.
export const LOOX_PUBLIC_STORE_ID =
  'pxRFO5d-in.96a8757ae842b2e1f4e62fea1671a7d70a167d08920df4711fad8d6f308a143a'
export const LOOX_PRODUCT_ID = '15827833684254'

export const SITE = {
  brand: 'RESPIRA',
  footer: 'www.respiratranquilidad.com · © 2026',
}
